import React from 'react'

import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    DialogTitle as MuiDialogTitle,
    Button,
    Typography,
} from '@mui/material'

interface Props {
    failureButtonText?: string
    message?: string
    icon?: React.ReactElement
    onFailure: () => void
    onSuccess: () => void
    open: boolean
    successButtonText?: string
    title?: string
    postMessageEm?: string
    disabled?: boolean
}

export const ConfirmDialog: React.VFC<Props> = ({
    failureButtonText = 'Cancel',
    message = 'Are you sure?',
    icon,
    onFailure,
    onSuccess,
    open,
    successButtonText = 'Ok',
    title = 'Confirm',
    postMessageEm,
    disabled,
}: Props) => {
    return (
        <Dialog open={open} onClose={onFailure} disableAutoFocus>
            <MuiDialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                {icon}
                <Typography variant="h6" component="span">
                    {title}
                </Typography>
            </MuiDialogTitle>
            <DialogContent>
                <DialogContentText>
                    {postMessageEm ? (
                        <>
                            {message} <em>{postMessageEm}</em>
                        </>
                    ) : (
                        message
                    )}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onFailure}>
                    <Typography variant="body1" color="primary">
                        {failureButtonText}
                    </Typography>
                </Button>
                <Button onClick={onSuccess} disabled={disabled} color="primary" autoFocus>
                    <Typography variant="body1" color="primary">
                        {successButtonText}
                    </Typography>
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export type { Props as ConfirmDialogProps }
